//=include _owl.carousel.min.js
//=include _jquery.cookie.js
//=include _jquery.mousewheel.js
//=include _jquery.jscrollpane.min.js

var map;
var geocoder;

function initMap() {
	geocoder = new google.maps.Geocoder();
	var osny = {lat: 49.0784104, lng: 2.0791929};
	var styles = [
		{
			featureType: 'poi',
			stylers: [{visibility: 'off'}]
		},
		{
			featureType: 'transit',
			elementType: 'labels.icon',
			stylers: [{visibility: 'off'}]
		}
	];

	map = new google.maps.Map(document.getElementById('map'), {
		center: osny,
		zoom: 14,
		styles: styles
	});

	geocoder.geocode({'address': 'Zone Commerciale de l\'Oseraie, 38 Chemin Poirier Charles Guérin, 95520 Osny'}, function(results, status) {
		if (status == 'OK') {
			map.setCenter(results[0].geometry.location);
			var marker = new google.maps.Marker({
				map: map,
				title: 'My Dreamland Osny',
				position: results[0].geometry.location
			});
		} else {
			console.log('Geocode was not successful for the following reason: ' + status);
		}
	});
}

$(document).ready(function() {
	var carrousel_players = {};

	if ($('#carrousel_accueil').length > 0) {
		var carrousel_accueil = $('#carrousel_accueil');
		carrousel_accueil.on('initialized.owl.carousel', function(event) {
			handleVideo();
		});
		carrousel_accueil.owlCarousel({
			loop: true,
			dots: false,
			nav: true,
			items: 1,
			margin: 0,
			lazyLoad: true,
			autoplay: true,
			autoplayTimeout: 4000,
			autoplayHoverPause: true,
			animateIn: 'fadeIn',
			animateOut: 'fadeOut'
		});
		carrousel_accueil.on('translated.owl.carousel', function(event) {
			handleVideo();
		});
		function handleVideo() {
			var current_slide = $('#carrousel_accueil .owl-item.active .carrousel_slide');
			var video_container = current_slide.find('.carrousel_player');
			if (video_container.length > 0) {
				var media = current_slide.find('.carrousel_player video')[0];
				carrousel_accueil.trigger('stop.owl.autoplay');
				if (carrousel_players[video_container.attr('id')] !== undefined) {
					carrousel_players[video_container.attr('id')].play();
				} else {
					media.addEventListener('ended', (event) => {
						media.pause();
						media.currentTime = 0;
						carrousel_accueil.trigger('next.owl.carousel');
						carrousel_accueil.trigger('play.owl.autoplay');
					});
					carrousel_players[video_container.attr('id')] = media;
				}
			}
		}
	}

	if ($('#carrousel_concept').length > 0) {
		$('#carrousel_concept').owlCarousel({
			autoplay: true,
			lazyLoad: true,
			loop: true,
			items: 1,
			margin: 0,
			nav: false,
			dots: true
		});
	}
});
$(window).load(function() {
	handle_svg_resize();

	/*if ($('#popup_accueil').length > 0 && $.cookie('home_video') === undefined) {
		$.fancybox.open($('#popup_accueil'), {
			afterShow: function() {
				$('#popup_accueil').jScrollPane();
			}
		});
		$.cookie('home_video', 'true', { expires: 1 });
	}*/
});

handle_svg_resize();
$(window).resize(debounce(handle_svg_resize, 100));

function handle_svg_resize() {
	if (!$('body').hasClass('mode_mobile')) {
		var window_width = $(window).width();

		if ($('.section_concept_content').length > 0) {
			var gabarit = $('.section_concept_content');
			var gabarit_height = gabarit.innerHeight();
			var svg = gabarit.find('.svg_blob').first();
			var svg_viewbox_array = svg[0].getAttribute('viewBox').split(' ');
			var svg_ratio = svg_viewbox_array[2] / svg_viewbox_array[3];
			var svg_width = gabarit_height * svg_ratio;
			svg.css({'width': svg_width + 'px', 'left': '-' + (svg_width - window_width) + 'px'});
		}
	}
}
